// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatRelative/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatRelative = convertToFP(fn, 2);
export default formatRelative;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatRelative/index.js
// module id = 885
// module chunks = 0